import React from 'react';
import { Table, TableBody, TableCell, TableRow, TableContainer } from '@mui/material';
import esArray from 'src/general_components/functionEsArray';

const ThreeRowsTable = ({ data }) => {
  const groupSize = 1;

  // Asegúrate de que `data` es un arreglo
  const dataArray = Array.isArray(data) ? data : [];
  // Divide los elementos del arreglo en grupos de tamaño `groupSize`
  const groups = dataArray.reduce((acc, _, index) => {
    if (index % groupSize === 0) {
      acc.push(data.slice(index, index + groupSize));
    }
    return acc;
  }, []);
  
  return (
    <TableContainer>
      <Table
        sx={{
          minWidth: "auto",
          fontSize: 13,
          fontFamily: 'Roboto, sans-serif',
        }}
        size="small"
        aria-label="a dense table"
      >
        <TableBody>
          {groups.map((group, groupIndex) => (
            <TableRow key={groupIndex}>
              {group.map((row, rowIndex) => (
                <React.Fragment key={row.id_metadatos}>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      fontSize: 13,
                      fontFamily: 'Roboto, sans-serif',
                    }}
                  >
                    <strong>{row.label_form}</strong>
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontSize: 13,
                      fontFamily: 'Roboto, sans-serif',
                    }}
                  >
                    {typeof row.valor === 'object' || row.valor === null ? '' : row.valor}
                  </TableCell>
                </React.Fragment>
              ))}
              {group.length < groupSize && (
                <TableCell colSpan={(groupSize - group.length) * 2} />
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const ContenidosMetadatosCell = (data) => {

  data = data.row;
  
  const contenidosMetadatos = data.contenidos_metadatos?.metadato || [];

  return <ThreeRowsTable data={esArray(contenidosMetadatos)} />;
};

export default ContenidosMetadatosCell;
